import React, {
  useEffect,
  useState,
  useRef,
  useImperativeHandle,
  forwardRef,
  useCallback,
} from "react";

const TypewriterText = forwardRef(({ text = "", speed = 25 }, ref) => {
  const [displayed, setDisplayed] = useState("");
  const [index, setIndex] = useState(0);
  const typingRef = useRef(true);

  const skipTyping = useCallback(() => {
    if (typingRef.current) {
      setDisplayed(text);
      setIndex(text.length);
      typingRef.current = false;
    }
  }, [text]);

  useImperativeHandle(ref, () => ({
    skipTyping,
  }));

  useEffect(() => {
    if (index >= text.length) {
      typingRef.current = false;
      return;
    }

    const timeout = setTimeout(() => {
      setDisplayed((prev) => prev + text.charAt(index));
      setIndex((prev) => prev + 1);
    }, speed);

    return () => clearTimeout(timeout);
  }, [index, text, speed]);

  useEffect(() => {
    setDisplayed("");
    setIndex(0);
    typingRef.current = true;
  }, [text]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.code === "Space" || e.code === "Enter") {
        skipTyping();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [skipTyping]);

  return <span>{displayed}</span>;
});

export default TypewriterText;
